let attestations = null;
// Язык вопросов не зависит от языка сайта: на сайте два языка, в тесте три.
const siteLang = localStorage.getItem("cl");
const attestationLang =
  localStorage.getItem("attestation_lang") ||
  (siteLang === "russian" ? "ru" : "latn");
export default {
  attestations,
  attestationLang,
};
